import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useMoodConfig } from "../stats/MoodChart";

export const CustomTooltip = ({ active, payload, label }) => {
    const { t } = useTranslation();
    // Usar el contexto en lugar de llamar a getMoodConfig directamente
    const moodConfig = useMoodConfig();

    if (!active || !payload || !payload.length) {
        return null;
    }

    const mood = payload[0].value;
    const moodInfo = moodConfig[mood] || {
        text: t('moodChart.notRecorded'),
        color: '#6B7280',
        emoji: '❓'
    };
    const data = payload[0].payload;

    // Verificar si tenemos datos de tipo morning o evening
    const hasMorning = data.type.morning;
    const hasEvening = data.type.evening;

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white dark:bg-gray-800 p-3 sm:p-4 shadow-lg rounded-lg border border-gray-200 dark:border-gray-700 max-w-xs"
        >
            <p className="text-xs sm:text-sm font-medium text-gray-600 dark:text-gray-400 mb-2">{data.fullDate}</p>
            <div className="flex items-center space-x-2 mb-2">
                <span className="text-xl sm:text-2xl">{moodInfo.emoji}</span>
                <div>
                    <p className="text-sm sm:text-base font-semibold" style={{ color: moodInfo.color }}>
                        {moodInfo.text}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">{moodInfo.description}</p>
                </div>
            </div>

            {/* Contenido según tipo de entrada */}
            <div className="space-y-2 mt-3">
                {hasMorning && (
                    <div className="pt-2 border-t border-gray-200 dark:border-gray-700">
                        <p className="text-xs font-medium text-indigo-500 mb-1">{t('journal.tabs.morning')}</p>
                        {data.content.morning?.gratitude && (
                            <div>
                                <p className="text-xs font-medium text-gray-600 dark:text-gray-400">{t('journal.prompts.morning.gratitude')}:</p>
                                <p className="text-xs italic text-gray-500 dark:text-gray-400">
                                    "{data.content.morning.gratitude}"
                                </p>
                            </div>
                        )}
                        {data.content.morning?.intention && (
                            <div className="mt-1">
                                <p className="text-xs font-medium text-gray-600 dark:text-gray-400">{t('journal.prompts.morning.intention')}:</p>
                                <p className="text-xs italic text-gray-500 dark:text-gray-400">
                                    "{data.content.morning.intention}"
                                </p>
                            </div>
                        )}
                    </div>
                )}

                {hasEvening && (
                    <div className="pt-2 border-t border-gray-200 dark:border-gray-700">
                        <p className="text-xs font-medium text-indigo-500 mb-1">{t('journal.tabs.evening')}</p>
                        {data.content.evening?.learnings && (
                            <div>
                                <p className="text-xs font-medium text-gray-600 dark:text-gray-400">{t('journal.prompts.evening.learnings')}:</p>
                                <p className="text-xs italic text-gray-500 dark:text-gray-400">
                                    "{data.content.evening.learnings}"
                                </p>
                            </div>
                        )}
                        {data.content.evening?.improvements && (
                            <div className="mt-1">
                                <p className="text-xs font-medium text-gray-600 dark:text-gray-400">{t('journal.prompts.evening.improvements')}:</p>
                                <p className="text-xs italic text-gray-500 dark:text-gray-400">
                                    "{data.content.evening.improvements}"
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <div className="mt-3 pt-2 border-t border-gray-200 dark:border-gray-700">
                <p className="text-xs text-gray-500 dark:text-gray-400 font-medium">{moodInfo.tip}</p>
            </div>
        </motion.div>
    );
};
